// Core
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Style
import { StyledSpecialEdition } from './style';

// Poster-style card for a special edition (a trip that has a visual app)
const SpecialEditionCard = (props) => {
  const { t } = useTranslation();
  // pass `trip` (an item from the API) or the individual props; explicit props win
  const {
    trip,
    title = trip?.tripName,
    image = trip?.coverImage,
    author = trip?.author?.userName,
    premium = trip?.isPremium,
    handleOnClick,
    ...rest
  } = props;
  return (
    <StyledSpecialEdition {...rest} onClick={handleOnClick}>
      <img src={image} alt={title} />
      <div className='__shade'></div>
      <span className='__tag'>{t('special_edition')}</span>
      {premium && <span className='__prem'>{t('premium')}</span>}
      <div className='__info'>
        <h2>{title}</h2>
        {author && <h5>{author}</h5>}
        <span className='__cta'>{t('explore_edition')}</span>
      </div>
    </StyledSpecialEdition>
  );
};

export default SpecialEditionCard;

SpecialEditionCard.propTypes = {
  trip: PropTypes.object,
  title: PropTypes.string,
  image: PropTypes.string,
  author: PropTypes.string,
  premium: PropTypes.bool,
  handleOnClick: PropTypes.func
};
